// extracted by mini-css-extract-plugin
export default {"wrapper":"FailureBulkAssignModal_wrapper__VhAMc","description":"FailureBulkAssignModal_description__34sxz","errorText":"FailureBulkAssignModal_errorText__8RPcD"};